import * as ReactDOM from "react-dom/client";

// Store roots in a WeakMap to allow proper cleanup
const roots = new WeakMap();

const browserHydrateFunction = () => {
  return (element, container) => {
    let root = roots.get(container);
    if (!root) {
      root = ReactDOM.createRoot(container);
      roots.set(container, root);
      // Store root reference on container for potential cleanup by Gatsby's head-export-handler
      container._reactRootContainer = root;
    }
    root.render(element);
  };
};

export default browserHydrateFunction;
